import { createAsyncThunk } from '@reduxjs/toolkit';

import { IUser } from '../UserSlice';
import { APIDataProvider, TApiResponse, AdminApiPaths } from '../../api';

export interface IGetStudentList {
  limit: number;
  offset: number;
  searchText?: string;
}

const apiDataProvider = new APIDataProvider();

const getStudentsModule = async (data: IGetStudentList) => {
  let _path = `${AdminApiPaths.students}?limit=${data.limit}&offset=${data.offset}`;

  if (data.searchText) {
    _path += `&searchText=${data.searchText}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<{
      offset: number;
      limit: number;
      totalDocs: number;
      docs: Array<IUser>;
    }>
  >(_path);

  return response.data;
};

export const adminGetStudents = createAsyncThunk(
  'admin/students/list',
  getStudentsModule
);

export const adminLoadMoreStudents = createAsyncThunk(
  'admin/students/loadMore',
  getStudentsModule
);

export default adminGetStudents;
